export default __webpack_public_path__ + "static/media/money.0a109b7f.svg";